import React  from 'react';
import {useHistory} from "react-router-dom";
import ClayButton from '@clayui/button';
import {ClayInput, ClaySelect} from '@clayui/form';
import ClayForm from '@clayui/form';
import ClayIcon from '@clayui/icon';
import ClayModal, { useModal } from '@clayui/modal';
import ClayPanel from '@clayui/panel';
import {saveDetailCoordinationSettings} from "../helpers/saveDetailCoordinationSettings";

export const spritemap = window.location.protocol + '//' + window.location.host + '/o/classic-theme/images/clay/icons.svg';

export const AddCoordination = ({ useAddCoordinationModal }) => {

    const { addCoordinationModal, setAddCoordinationModal } = useAddCoordinationModal();

    const { observer, onClose } = useModal({
        onClose: () => setAddCoordinationModal({ ...setAddCoordinationModal, visible: false })
    });

    const history = useHistory();

    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData(document.getElementById('addCoordinationForm'));

        const formCode = formData.get("productCode");

        saveDetailCoordinationSettings(formCode).then(myobjet => {
                history.push(`detail/${myobjet.idSetting}`)
        });
    }

    return (
        <>
            {
                addCoordinationModal.visible && (
                    <ClayModal
                        observer={observer}
                        size="lg"
                        spritemap={spritemap}
                        status="info" >
                        <form id="addCoordinationForm" onSubmit={handleSubmit}>
                            <ClayModal.Body style={{maxHeight: "85vh"}}>
                                <ClayPanel
                                    collapsable
                                    displayTitle="Nueva Coordinacion"
                                    displayType="secondary"
                                    spritemap={spritemap}
                                    defaultExpanded >
                                    <ClayPanel.Body>
                                        <ClayForm.Group>
                                            <ClayInput.Group>
                                                <ClayInput.GroupItem>
                                                    <label htmlFor="newCoordinationProduct">Producto
                                                        <span className="reference-mark">
                                                            <ClayIcon spritemap={window.$spritemap} symbol="asterisk" />
                                                        </span>
                                                    </label>
                                                    <ClaySelect name="productCode" id="type" required>
                                                        {
                                                            addCoordinationModal.data.products && (
                                                                <>
                                                                    <ClaySelect.Option label="Seleccione" value='' />
                                                                    {addCoordinationModal.data.products.map(item => (
                                                                        <ClaySelect.Option disabled={addCoordinationModal.data.idsLista.includes(item.formCode)}
                                                                            key={item.formCode}
                                                                            label={item.name}
                                                                            value={item.formCode}
                                                                        />
                                                                    ))
                                                                    }
                                                                </>
                                                            )
                                                        }
                                                    </ClaySelect>
                                                </ClayInput.GroupItem>
                                            </ClayInput.Group>
                                        </ClayForm.Group>
                                    </ClayPanel.Body>
                                </ClayPanel>
                            </ClayModal.Body>
                            <ClayModal.Footer
                                first={
                                    <ClayButton.Group spaced>
                                        <ClayButton onClick={onClose} displayType="secondary">{"Cancelar"}</ClayButton>
                                    </ClayButton.Group>
                                }
                                last={<ClayButton type="submit">{"Guardar"}</ClayButton>}
                            />
                        </form>
                    </ClayModal>
                )
            }
        </>
    )
}